import React from 'react'
import { ImLocation2 } from 'react-icons/im';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import garden from './images/sold/garden.jpg'
import house from './images/sold/house.jpg'
import sheep from './images/sold/sheep.jpg'
import horse from './images/sold/horse.jpg'
import tree from './images/sold/tree.jpg'
import lake from './images/sold/lake.jpg'
import van from './images/sold/van.jpg'
import field from './images/sold/field.jpg'
import desert from './images/sold/desert.jpg'
import boy from './images/sold/boy.jpg'
import manor from './images/sold/manor.jpg'
import green from './images/sold/green.jpg'
import guest from './images/sold/guest.jpg'


const Sold = () => {
    return (
        <>
            <div className="md:py-[3rem]">

                <div class="grid grid-cols-12 gap-5 mx-5 md:mx-[7rem] md:py-6  ">

                    <div class="md:col-span-4 col-span-12 md:my-0 my-10">

                        <div className='relative'>
                            <div className='sold absolute w-[101px] h-[69px] left-0 top-0  z-10'>sold</div>
                            <Carousel showThumbs={false} >
                                {/* <img src={sold} alt="sold"  className='h-[70px] w-[101px] hidden absolute left-0 top-0 bg-no-repeat'/> */}
                                {/* <div className="sold "></div> */}

                                <div>
                                    <img src={sheep} alt="image1" />
                                </div>
                                <div>
                                    <img src={garden} alt="image2" />
                                </div>
                                <div>
                                    <img src={house} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>EMERALD</h1>
                        </div>
                        <div className=" mx-1 font-black"><h1>376 Mt Dangar Road</h1></div>
                        <div className="mx-1 text-gray-400"><h1>4386 ha</h1></div>

                    </div>

                    <div class="md:col-span-4 col-span-12 ">

                        <div className='relative'>
                            <div className='sold absolute w-[101px] h-[69px] left-0 top-0  z-10'>sold</div>
                            <Carousel showThumbs={false} >
                                {/* <img src={sold} alt="sold"  className='h-[70px] w-[101px] hidden absolute left-0 top-0 bg-no-repeat'/> */}
                                {/* <div className="sold "></div> */}

                                <div>
                                    <img src={lake} alt="image1" />
                                </div>
                                <div>
                                    <img src={sheep} alt="image2" />
                                </div>
                                <div>
                                    <img src={house} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>YUNA</h1>
                        </div>
                        <div className="mx-1 font-black"><h1>1080 Wandin Road</h1></div>
                        <div className="mx-1 text-gray-400  "><h1>4366 ha</h1></div>

                    </div>

                    <div class="md:col-span-4 col-span-12  md:my-0 my-10">

                        <div className='relative'>
                            <div className='sold absolute w-[101px] h-[69px] left-0 top-0  z-10'>sold</div>
                            <Carousel showThumbs={false} >


                                <div>
                                    <img src={house} alt="image1" />
                                </div>
                                <div>
                                    <img src={garden} alt="image2" />
                                </div>
                                <div>
                                    <img src={lake} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>BINALONG</h1>
                        </div>
                        <div className="  mx-1 font-black"><h1>222 Grogans Road</h1></div>
                        <div className="  mx-1 text-gray-400 "><h1>50 ha</h1></div>

                    </div>

                </div>


                <div class="grid grid-cols-12 gap-5 mx-5 md:mx-[7rem] md:py-6  ">

                    <div class="md:col-span-4 col-span-12 md:my-0 my-10 ">

                        <div className='relative'>
                            <div className='sold absolute w-[101px] h-[69px] left-0 top-0  z-10'>sold</div>
                            <Carousel showThumbs={false} >
                                {/* <img src={sold} alt="sold"  className='h-[70px] w-[101px] hidden absolute left-0 top-0 bg-no-repeat'/> */}
                                {/* <div className="sold "></div> */}

                                <div>
                                    <img src={horse} alt="image1" />
                                </div>
                                <div>
                                    <img src={garden} alt="image2" />
                                </div>
                                <div>
                                    <img src={tree} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>YASS</h1>
                        </div>
                        <div className=" mx-1 font-black"><h1>968 Boambolo Road</h1></div>
                        <div className="mx-1 text-gray-400 "><h1>758 ha</h1></div>

                    </div>

                    <div class="md:col-span-4 col-span-12">

                        <div className='relative'>
                            <div className='sold absolute w-[101px] h-[69px] left-0 top-0  z-10'>sold</div>
                            <Carousel showThumbs={false} >
                                {/* <img src={sold} alt="sold"  className='h-[70px] w-[101px] hidden absolute left-0 top-0 bg-no-repeat'/> */}
                                {/* <div className="sold "></div> */}

                                <div>
                                    <img src={van} alt="image1" />
                                </div>
                                <div>
                                    <img src={field} alt="image2" />
                                </div>
                                <div>
                                    <img src={house} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>KATHERINE</h1>
                        </div>
                        <div className="mx-1 font-black"><h1>16 Wallace Court</h1></div>
                        <div className="mx-1 text-gray-400 "><h1>870 sqm</h1></div>

                    </div>

                    <div class="md:col-span-4 col-span-12  md:my-0 my-10">

                        <div className='relative'>
                            <div className='sold absolute w-[101px] h-[69px] left-0 top-0  z-10'>sold</div>
                            <Carousel showThumbs={false} >
                                {/* <img src={sold} alt="sold"  className='h-[70px] w-[101px] hidden absolute left-0 top-0 bg-no-repeat'/> */}
                                {/* <div className="sold "></div> */}

                                <div>
                                    <img src={sheep} alt="image1" />
                                </div>
                                <div>
                                    <img src={garden} alt="image2" />
                                </div>
                                <div>
                                    <img src={house} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>YASS</h1>
                        </div>
                        <div className="mx-1 font-black"><h1>32 Church St</h1></div>
                        <div className="mx-1 text-gray-400"><h1>924 sqm</h1></div>

                    </div>

                </div>



                <div class="grid grid-cols-12 gap-5 mx-5 md:mx-[7rem]  md:py-6  ">

                    <div class="md:col-span-4 col-span-12 md:my-0 my-10 ">

                        <div className='relative'>
                            <div className='sold absolute w-[101px] h-[69px] left-0 top-0  z-10'>sold</div>
                            <Carousel showThumbs={false} >
                                {/* <img src={sold} alt="sold"  className='h-[70px] w-[101px] hidden absolute left-0 top-0 bg-no-repeat'/> */}
                                {/* <div className="sold "></div> */}

                                <div>
                                    <img src={desert} alt="image1" />
                                </div>
                                <div>
                                    <img src={garden} alt="image2" />
                                </div>
                                <div>
                                    <img src={house} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>RYE PARK</h1>
                        </div>
                        <div className="mx-1 font-black"><h1>Mount Buffalo</h1></div>
                        <div className="mx-1 text-gray-400"><h1>869 ha</h1></div>

                    </div>

                    <div class="md:col-span-4 col-span-12">

                        <div className='relative'>
                            <div className='sold absolute w-[101px] h-[69px] left-0 top-0  z-10'>sold</div>
                            <Carousel showThumbs={false} >
                                {/* <img src={sold} alt="sold"  className='h-[70px] w-[101px] hidden absolute left-0 top-0 bg-no-repeat'/> */}
                                {/* <div className="sold "></div> */}

                                <div>
                                    <img src={boy} alt="image1" />
                                </div>
                                <div>
                                    <img src={garden} alt="image2" />
                                </div>
                                <div>
                                    <img src={house} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>BOOKHAM</h1>
                        </div>
                        <div className="mx-1 font-black"><h1>Baroone</h1></div>
                        <div className="mx-1 text-gray-400"><h1>198 ha</h1></div>

                    </div>

                    <div class="md:col-span-4 col-span-12  md:my-0 my-10 ">

                        <div className='relative'>
                            <div className='sold absolute w-[101px] h-[69px] left-0 top-0  z-10'>sold</div>
                            <Carousel showThumbs={false} >
                                {/* <img src={sold} alt="sold"  className='h-[70px] w-[101px] hidden absolute left-0 top-0 bg-no-repeat'/> */}
                                {/* <div className="sold "></div> */}

                                <div>
                                    <img src={house} alt="image1" />
                                </div>
                                <div>
                                    <img src={garden} alt="image2" />
                                </div>
                                <div>
                                    <img src={house} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>GUNNING</h1>
                        </div>
                        <div className="mx-1 font-black"><h1>South Winstone</h1></div>
                        <div className="mx-1 text-gray-400"><h1>259 ha</h1></div>

                    </div>

                </div>



                <div class="grid grid-cols-12 gap-5 mx-5 md:mx-[7rem] md:py-6 ">

                    <div class="md:col-span-4 col-span-12 md:my-0 my-10">

                        <div className='relative'>
                            <div className='sold absolute w-[101px] h-[69px] left-0 top-0  z-10'>sold</div>
                            <Carousel showThumbs={false} >
                                {/* <img src={sold} alt="sold"  className='h-[70px] w-[101px] hidden absolute left-0 top-0 bg-no-repeat'/> */}
                                {/* <div className="sold "></div> */}

                                <div>
                                    <img src={manor} alt="image1" />
                                </div>
                                <div>
                                    <img src={green} alt="image2" />
                                </div>
                                <div>
                                    <img src={house} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="#">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>EMERALD</h1>
                        </div>
                        <div className="mx-1 font-black"><h1>376 Mt Dangar Road</h1></div>
                        <div className="mx-1 text-gray-400 "><h1>4386 ha</h1></div>

                    </div>

                    <div class="md:col-span-4 col-span-12 ">

                        <div className='relative'>
                            <div className='sold absolute w-[101px] h-[69px] left-0 top-0  z-10'>sold</div>
                            <Carousel showThumbs={false} >
                                {/* <img src={sold} alt="sold"  className='h-[70px] w-[101px] hidden absolute left-0 top-0 bg-no-repeat'/> */}
                                {/* <div className="sold "></div> */}

                                <div>
                                    <img src={green} alt="image1" />
                                </div>
                                <div>
                                    <img src={garden} alt="image2" />
                                </div>
                                <div>
                                    <img src={manor} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="#">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>YUNA</h1>
                        </div>
                        <div className="mx-1 font-black"><h1>1080 Wandin Road</h1></div>
                        <div className="mx-1 text-gray-400"><h1>4366 ha</h1></div>

                    </div>

                    <div class="md:col-span-4 col-span-12  md:my-0 my-10">

                        <div className='relative'>
                            <div className='sold absolute w-[101px] h-[69px] left-0 top-0  z-10'>sold</div>
                            <Carousel showThumbs={false} >
                                {/* <img src={sold} alt="sold"  className='h-[70px] w-[101px] hidden absolute left-0 top-0 bg-no-repeat'/> */}
                                {/* <div className="sold "></div> */}

                                <div>
                                    <img src={guest} alt="image1" />
                                </div>
                                <div>
                                    <img src={manor} alt="image2" />
                                </div>
                                <div>
                                    <img src={green} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="#">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>EMERALD</h1>
                        </div>
                        <div className="mx-1 font-black"><h1>376 Mt Dangar Road</h1></div>
                        <div className="mx-1 text-gray-400"><h1>4386 ha</h1></div>

                    </div>

                </div>


                <div class="grid grid-cols-12 gap-5 mx-5 md:mx-[7rem] md:py-6  ">

                    <div class="md:col-span-4 col-span-12 md:my-0 my-10">

                        <div className='relative'>
                            <div className='sold absolute w-[101px] h-[69px] left-0 top-0  z-10'>sold</div>
                            <Carousel showThumbs={false} >
                                {/* <img src={sold} alt="sold"  className='h-[70px] w-[101px] hidden absolute left-0 top-0 bg-no-repeat'/> */}
                                {/* <div className="sold "></div> */}

                                <div>
                                    <img src={horse} alt="image1" />
                                </div>
                                <div>
                                    <img src={garden} alt="image2" />
                                </div>
                                <div>
                                    <img src={tree} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="#">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>YASS</h1>
                        </div>
                        <div className="mx-1 font-black"><h1>968 Boambolo Road</h1></div>
                        <div className="mx-1 text-gray-400"><h1>758 ha</h1></div>

                    </div>

                    <div class="md:col-span-4 col-span-12 ">

                        <div className='relative'>
                            <div className='sold absolute w-[101px] h-[69px] left-0 top-0  z-10'>sold</div>
                            <Carousel showThumbs={false} >
                                {/* <img src={sold} alt="sold"  className='h-[70px] w-[101px] hidden absolute left-0 top-0 bg-no-repeat'/> */}
                                {/* <div className="sold "></div> */}

                                <div>
                                    <img src={van} alt="image1" />
                                </div>
                                <div>
                                    <img src={field} alt="image2" />
                                </div>
                                <div>
                                    <img src={house} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="#">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>KATHERINE</h1>
                        </div>
                        <div className="mx-1 font-black"><h1>16 Wallace Court</h1></div>
                        <div className="mx-1 text-gray-400"><h1>870 sqm</h1></div>

                    </div>

                    <div class="md:col-span-4 col-span-12  md:my-0 my-10  ">

                        <div className='relative'>
                            <div className='sold absolute w-[101px] h-[69px] left-0 top-0  z-10'>sold</div>
                            <Carousel showThumbs={false} >
                                {/* <img src={sold} alt="sold"  className='h-[70px] w-[101px] hidden absolute left-0 top-0 bg-no-repeat'/> */}
                                {/* <div className="sold "></div> */}

                                <div>
                                    <img src={sheep} alt="image1" />
                                </div>
                                <div>
                                    <img src={garden} alt="image2" />
                                </div>
                                <div>
                                    <img src={house} alt="image3" />
                                </div>
                            </Carousel>
                            <a href="#">
                                <div className="hover:opacity-100 absolute top-0 opacity-0 w-[100%] h-[100%] bg-[rgba(0,74,139,0.6)]">
                                    <div className=" border-t border-b border-white text-white absolute top-[6.5rem] left-[8rem]  ">
                                        <span className="font-bold tracking-widest text-center text-[12px]">FIND OUT MORE</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        <div className="flex mt-4">
                            <ImLocation2 className='text-xl  text-[#00498A]' /><h1 className='text-[12px] my-1 font-black text-[#00498A]'>YASS</h1>
                        </div>
                        <div className="mx-1 font-black"><h1>32 Church St</h1></div>
                        <div className="mx-1 text-gray-400"><h1>924 sqm</h1></div>

                    </div>

                </div>

            </div>
        </>
    )
}

export default Sold